import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import caseMagageApi from '@/apis/caseManage';
import scheduleManageApi from '@/apis/scheduleManage';

var CardMoreButton = /*#__PURE__*/function (_Vue) {
  _inherits(CardMoreButton, _Vue);

  var _super = _createSuper(CardMoreButton);

  function CardMoreButton() {
    var _this;

    _classCallCheck(this, CardMoreButton);

    _this = _super.apply(this, arguments);
    _this.isShowPopover = false;
    return _this;
  }

  _createClass(CardMoreButton, [{
    key: "popoverShow",
    value: function popoverShow() {
      this.isShowPopover = true;
    }
  }, {
    key: "popoverHide",
    value: function popoverHide() {
      this.isShowPopover = false;
    }
  }, {
    key: "doCaseDetail",
    value: function doCaseDetail() {
      if (this.onCaseDetail) {
        this.onCaseDetail();
      } else {
        this.$router.push("/index/caseInfo/".concat(this.caseId));
      }
    }
  }, {
    key: "doPlanDetail",
    value: function doPlanDetail() {
      if (this.onCaseDetail) {
        this.onPlanDetail();
      } else {
        this.$router.push({
          name: 'CaseInfo'
        });
      }
    }
  }, {
    key: "doAgainSchedule",
    value: function doAgainSchedule() {
      if (this.onCaseDetail) {
        this.onPlanDetail();
      } else {
        this.$router.push("/index/scheduleUpdate/".concat(this.scheduleId));
      }
    }
  }, {
    key: "doCancelSchedule",
    value: function doCancelSchedule() {
      var _this2 = this;

      this.$confirm('此操作将取消该排期, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question'
      }).then(function (action) {
        scheduleManageApi.delete({
          scheduleId: _this2.scheduleId
        }).then(function (res) {
          if (_this2.onCancelScheduleSuccess) {
            _this2.onCancelScheduleSuccess();
          }

          _this2.$message.success('取消排期成功');
        }).catch(function (_) {});
      }).catch(function () {});
    }
  }, {
    key: "doEditCase",
    value: function doEditCase() {
      if (this.onEditCase) {
        this.onEditCase();
      } else {
        this.$router.push("/index/CaseUpdate/".concat(this.caseId));
      }
    }
  }, {
    key: "doDeleteCase",
    value: function doDeleteCase() {
      var _this3 = this;

      this.$confirm('此操作将删除该案件, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question'
      }).then(function (action) {
        caseMagageApi.deleteCase({
          caseIndexCode: _this3.caseId
        }).then(function (_) {
          if (_this3.onDeleteCaseSuccess) {
            _this3.onDeleteCaseSuccess();
          }

          _this3.$message.success('删除案件成功');
        }).catch(function (_) {});
      }).catch(function () {});
    } // 删除已排期的案件

  }, {
    key: "doDeletePlanCase",
    value: function doDeletePlanCase() {
      var _this4 = this;

      this.$confirm('此操作将删除该案件, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question'
      }).then(function (action) {
        scheduleManageApi.deleteScheduleAndCase({
          caseId: _this4.caseId,
          scheduleId: _this4.scheduleId
        }).then(function (_) {
          if (_this4.onDeleteCasePlanSuccess) {
            _this4.onDeleteCasePlanSuccess();
          }

          _this4.$message.success('删除案件成功');
        }).catch(function (_) {});
      }).catch(function () {});
    }
  }, {
    key: "doUploadEvidence",
    value: function doUploadEvidence() {
      if (this.onUploadEvidence) {
        this.onUploadEvidence();
      } else {
        this.$router.push("/index/uploadEvidence/".concat(this.caseId));
      }
    }
  }]);

  return CardMoreButton;
}(Vue);

__decorate([Prop()], CardMoreButton.prototype, "caseId", void 0);

__decorate([Prop()], CardMoreButton.prototype, "scheduleId", void 0);

__decorate([Prop({
  required: true
})], CardMoreButton.prototype, "eventList", void 0);

__decorate([Prop()], CardMoreButton.prototype, "onCaseDetail", void 0);

__decorate([Prop()], CardMoreButton.prototype, "onPlanDetail", void 0);

__decorate([Prop()], CardMoreButton.prototype, "onAgainSchedule", void 0);

__decorate([Prop()], CardMoreButton.prototype, "onCancelScheduleSuccess", void 0);

__decorate([Prop()], CardMoreButton.prototype, "onEditCase", void 0);

__decorate([Prop()], CardMoreButton.prototype, "onDeleteCaseSuccess", void 0);

__decorate([Prop()], CardMoreButton.prototype, "onDeleteCasePlanSuccess", void 0);

__decorate([Prop()], CardMoreButton.prototype, "onUploadEvidence", void 0);

CardMoreButton = __decorate([Component], CardMoreButton);
export default CardMoreButton;